import * as React from 'react';
import { ViewState } from 'react-map-gl';

import { ZoomInButton, ZoomOutButton, CompassButton } from '@independent-software/mapbox-ext/controls/buttons';
import { ScaleControl } from '@independent-software/mapbox-ext/controls/ScaleControl';
import { Geocoder } from '@independent-software/mapbox-ext/controls/Geocoder';
import { DefaultSkin } from '@independent-software/mapbox-ext/types/Skin';
import { App } from '../../App';
import { ZoomOutHint } from './ZoomOutHint';
import { ZoomInHint } from './ZoomInHint';
import { CompassHint } from './CompassHint';

const MapControls = (props: ViewState) => <>
  <ScaleControl {...props} x={-32} y={-32}/>
  <ZoomOutButton {...props} skin={DefaultSkin} x={-32} y={-32 - 1*48} hint={<ZoomOutHint/>}/>
  <ZoomInButton {...props} skin={DefaultSkin} x={-32} y={-32 - 2*48} hint={<ZoomInHint/>}/>
  <CompassButton {...props} skin={DefaultSkin} x={-32} y={-32 - 3*48} hint={<CompassHint/>}/>
  <Geocoder access_token={App.config.mapboxKey} skin={DefaultSkin} x={-32} y={36}/>  
</>

export { MapControls }
